module.exports = __webpack_public_path__ + "img/fh_slider4.aaedba25.jpg";